import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IResponse } from 'src/app/pages/base/interfaces';
import { MaestroModel } from '../maestro.model';
import { HistorialNotificacionService } from 'src/app/services/notificacion/historial_notificacion.service';


export class HistorialNotificacion extends MaestroModel {

    public static RECORD_NAME = 'historial_notificaciones';
    public static CODIGO_REGISTRO = 'historial_notificacion';
    public static CODIGO_MODULO = 'notificacion';
    public static NOMBRE_SINGULAR = 'Historial Notificacion';
    public static NOMBRE_PLURAL = 'Historial Notificaciones';

    public static TIPOS = [
        { valor: 1, nombre: 'SMS'},
        { valor: 2, nombre: 'WHATSAPP'},
        { valor: 3, nombre: 'CORREO'},
    ]

    public static TIPO_SMS = 1;
    public static TIPO_WHATSAPP = 2;
    public static TIPO_CORREO = 3;

    // Tipos de origen
    public static TIPOS_ORIGEN = [
        { valor: 'contactos', nombre: 'Lista de Contactos' },
        { valor: 'excel', nombre: 'Archivo Excel/CSV' },
        { valor: 'seleccion', nombre: 'Selección Manual' }
    ];

    private _idEmpresa:                 number;
    private _nombreEmpresa:             string;
    private _fecha:                     Date;
    private _descripcion:               string;
    private _destinatario:              string;
    private _tipo:                      number;
    private _archivo:                   string;
    private _totalNoEnviado:            number;
    private _totalEnviado:              number;
    // Estado real del envio, derivado del job por el backend.
    private _estadoEnvio:               Record<string, any> | null;
    private _idWhatsappTemplate:        number;
    private _nombreWhatsappTemplate:   string;
    private _contentVariables:         string;
    private _origen:                    string;  // 'contactos', 'excel', 'seleccion'
    private _jobId:                     number;  // ID del job si es procesamiento asíncrono



    constructor() {
        super();
        this._idEmpresa = this.seguridad.getCurrentUser()?.id_empresa;
        this._nombreEmpresa = this.seguridad.getCurrentUser()?.nombre_empresa;
        this.fecha = new Date();
        this._totalEnviado = 0;
        this._totalNoEnviado = 0;
    }

    public set idEmpresa( idEmpresa: number ) { this._idEmpresa = idEmpresa };
    public get idEmpresa(): number { return this._idEmpresa };

    public set nombreEmpresa( nombreEmpresa: string ) { this._nombreEmpresa = nombreEmpresa };
    public get nombreEmpresa(): string { return this._nombreEmpresa };

    public set fecha( fecha: Date ) { this._fecha = fecha };
    public get fecha(): Date { return this._fecha };

    public set descripcion( descripcion: string ) { this._descripcion = descripcion };
    public get descripcion(): string { return this._descripcion };

    public set destinatario( destinatario: string ) { this._destinatario = destinatario };
    public get destinatario(): string { return this._destinatario };

    public set archivo( archivo: string ) { this._archivo = archivo };
    public get archivo(): string { return this._archivo };

    public set tipo( tipo: number ) { this._tipo = tipo };
    public get tipo(): number { return this._tipo };

    public set totalEnviado( totalEnviado: number ) { this._totalEnviado = totalEnviado };
    public get totalEnviado(): number { return this._totalEnviado };

    public set estadoEnvio( estadoEnvio: Record<string, any> | null ) { this._estadoEnvio = estadoEnvio };
    public get estadoEnvio(): Record<string, any> | null { return this._estadoEnvio };

    public set totalNoEnviado( totalNoEnviado: number ) { this._totalEnviado = totalNoEnviado };
    public get totalNoEnviado(): number { return this._totalNoEnviado };

    public set idWhatsappTemplate( idWhatsappTemplate: number ) { this._idWhatsappTemplate = idWhatsappTemplate };
    public get idWhatsappTemplate(): number { return this._idWhatsappTemplate };

    public set nombreWhatsappTemplate( nombreWhatsappTemplate: string ) { this._nombreWhatsappTemplate = nombreWhatsappTemplate };
    public get nombreWhatsappTemplate(): string { return this._nombreWhatsappTemplate };

    public set contentVariables( contentVariables: string ) { this._contentVariables = contentVariables };
    public get contentVariables(): string { return this._contentVariables };

    public set origen( origen: string ) { this._origen = origen };
    public get origen(): string { return this._origen || 'contactos' };

    public set jobId( jobId: number ) { this._jobId = jobId };
    public get jobId(): number { return this._jobId };

    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'nombre', label: 'Nombre', type: 'text' },
            { field: 'total_enviado', label: 'total Enviado', type: 'number' },
        ]
    }

    async cargarDatos( objeto: Record<string, any> ) {
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.nombre_empresa;
        this._fecha = objeto.fecha ? new Date(objeto.fecha): objeto.fecha;
        this._archivo = objeto.archivo;
        this._descripcion = objeto.descripcion;
        this._tipo = objeto.tipo;
        this._totalEnviado = objeto.total_enviado;
        this._totalNoEnviado = objeto.total_no_enviado;
        this._idWhatsappTemplate = objeto.id_whatsapp_template;
        this._nombreWhatsappTemplate = objeto.nombre_whatsapp_template;
        this._contentVariables = objeto.content_variables;
        this._origen = objeto.origen || 'contactos';
        this._jobId = objeto.job_id;
        // Solo lectura: lo calcula el backend a partir del job y no va al
        // formulario, porque no es un dato editable de la campana.
        this._estadoEnvio = objeto.estado_envio || null;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        await this.cargarDatos( objeto );
    }

    async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        await this.cargarDatos( objeto );
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa, Validators.required));
        fg.addControl("fecha", new FormControl(this._fecha));
        fg.addControl("descripcion", new FormControl(this._descripcion));
        fg.addControl("tipo", new FormControl(this._tipo));
        fg.addControl("total_enviado", new FormControl(this._totalEnviado));
        fg.addControl("total_no_enviado", new FormControl(this._totalNoEnviado));
        fg.addControl("archivo", new FormControl(this._archivo));
        fg.addControl("id_whatsapp_template", new FormControl(this._idWhatsappTemplate));
        fg.addControl("nombre_whatsapp_template", new FormControl(this._nombreWhatsappTemplate));
        fg.addControl("content_variables", new FormControl(this._contentVariables));
        fg.addControl("origen", new FormControl(this._origen || 'contactos'));
        fg.addControl("job_id", new FormControl(this._jobId));
        return fg;
    }

    async guardar( service: HistorialNotificacionService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    async actualizar( service: HistorialNotificacionService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    async eliminar( service: HistorialNotificacionService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}